import React, { useState } from 'react';

export default function NotifyModal({ players, onConfirm, onClose }) {
    const [checkedIds, setCheckedIds] = useState(players.map(p => p.id));

    const toggle = (id) =>
        setCheckedIds(prev =>
            prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
        );

    const selectAll  = () => setCheckedIds(players.map(p => p.id));
    const selectNone = () => setCheckedIds([]);

    const getInitials = (p) => (p.name ? p.name[0] : '?').toUpperCase();

    return (
        <div style={{
            position: 'fixed', inset: 0, zIndex: 1000,
            backgroundColor: 'rgba(0,0,0,0.4)',
            display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
            <div style={{
                background: 'white', borderRadius: '16px', padding: '32px',
                maxWidth: '440px', width: '90%',
                boxShadow: '0 20px 60px rgba(0,0,0,0.2)'
            }}>
                {/* Cabecera */}
                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                    <div style={{
                        width: '56px', height: '56px', borderRadius: '50%',
                        backgroundColor: '#DBEAFE', display: 'flex',
                        alignItems: 'center', justifyContent: 'center',
                        margin: '0 auto 12px'
                    }}>
                        <i className="fa fa-envelope" style={{ fontSize: '1.4rem', color: '#2563EB' }} />
                    </div>
                    <h3 style={{ margin: '0 0 6px', fontSize: '1.1rem', color: '#1e293b' }}>
                        ¿Enviar notificaciones?
                    </h3>
                    <p style={{ margin: 0, color: '#64748B', fontSize: '0.85rem' }}>
                        Convocatoria guardada. Selecciona a quién notificar por email.
                    </p>
                </div>

                {/* Lista de jugadoras */}
                <div style={{ marginBottom: '20px', maxHeight: '260px', overflowY: 'auto' }}>

                    {/* Selección rápida */}
                    <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
                        <button
                            onClick={selectAll}
                            style={{
                                fontSize: '0.75rem', padding: '4px 10px', borderRadius: '6px',
                                border: '1px solid #CBD5E1', background: 'white',
                                cursor: 'pointer', color: '#475569'
                            }}
                        >
                            Todas
                        </button>
                        <button
                            onClick={selectNone}
                            style={{
                                fontSize: '0.75rem', padding: '4px 10px', borderRadius: '6px',
                                border: '1px solid #CBD5E1', background: 'white',
                                cursor: 'pointer', color: '#475569'
                            }}
                        >
                            Ninguna
                        </button>
                    </div>

                    {players.map(p => (
                        <label
                            key={p.id}
                            style={{
                                display: 'flex', alignItems: 'center', gap: '10px',
                                padding: '8px 10px', borderRadius: '8px', cursor: 'pointer',
                                backgroundColor: checkedIds.includes(p.id) ? '#F0FDF4' : 'white',
                                border: checkedIds.includes(p.id) ? '1px solid #BBF7D0' : '1px solid #F1F5F9',
                                marginBottom: '6px', transition: 'all 0.15s'
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={checkedIds.includes(p.id)}
                                onChange={() => toggle(p.id)}
                                style={{ accentColor: '#16a34a', width: '16px', height: '16px', flexShrink: 0 }}
                            />
                            <div
                                style={{
                                    width: '28px', height: '28px', borderRadius: '50%',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    fontSize: '0.75rem', fontWeight: 700, color: 'white', flexShrink: 0,
                                    background: p.isReserve ? '#F59E0B' : '#10B981'
                                }}
                            >
                                {getInitials(p)}
                            </div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <span style={{ fontWeight: 500, fontSize: '0.9rem' }}>
                                    {p.name} {p.lastName}
                                </span>
                                <span style={{
                                    marginLeft: '8px', fontSize: '0.7rem', padding: '1px 6px',
                                    borderRadius: '10px', fontWeight: 600,
                                    background: p.isReserve ? '#FEF9C3' : '#DCFCE7',
                                    color: p.isReserve ? '#854D0E' : '#166534'
                                }}>
                                    {p.isReserve ? 'Reserva' : 'Convocada'}
                                </span>
                            </div>
                        </label>
                    ))}
                </div>

                {/* Acciones */}
                <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                    <button
                        onClick={onClose}
                        style={{
                            padding: '10px 20px', borderRadius: '8px',
                            border: '1px solid #E2E8F0', background: 'white',
                            color: '#64748B', cursor: 'pointer',
                            fontWeight: 600, fontSize: '0.9rem'
                        }}
                    >
                        No enviar
                    </button>
                    <button
                        onClick={() => onConfirm(checkedIds)}
                        disabled={checkedIds.length === 0}
                        style={{
                            padding: '10px 20px', borderRadius: '8px',
                            border: 'none', background: '#2563EB',
                            color: 'white', cursor: checkedIds.length === 0 ? 'not-allowed' : 'pointer',
                            fontWeight: 600, fontSize: '0.9rem',
                            opacity: checkedIds.length === 0 ? 0.5 : 1,
                            display: 'flex', alignItems: 'center', gap: '6px'
                        }}
                    >
                        <i className="fa fa-paper-plane" />
                        Enviar ({checkedIds.length})
                    </button>
                </div>
            </div>
        </div>
    );
}